import { Page, Visitor } from '../../types';

export function getPageDataObjectWithType(type?: string, pageType = '', environmentName?: string, fullType?: string): Page {
  return {
    businessUnit: 'ELS:RP:ST',
    environment: environmentName === 'qa' ? 'cert' : environmentName as Page['environment'],
    language: 'en',
    loadTimestamp: Date.now().toString(),
    name: type ? `auth-pages:${type}` : fullType || '',
    type: pageType,
    noTracking: 'false',
    productName: 'SD',
  };
}

function getAccessType(assocType?: string, anonymity?: string): string {
  if (anonymity === 'INDIVIDUAL') {
    return assocType ? `ae:REG_${assocType}` : 'ae:REG_anonymous';
  }
  return anonymity ? `ae:${anonymity}` : 'ae:anonymous';
}

function getLoginStatus(anonymity?: string): string {
  return anonymity === 'INDIVIDUAL' ? 'logged in' : 'anonymous';
}

export function getVisitorObject(
  ip: string,
  webUserId: string,
  accountId?: string,
  accountName?: string,
  anonymity?: string,
  assocType?: string,
  sessionId?: string,
): Visitor {
  return {
    accessType: getAccessType(assocType, anonymity),
    accountId: accountId ? `ae:${accountId}` : 'anonymous',
    accountName: accountName ? `ae:${accountName}` : 'anonymous',
    ipAddress: ip,
    loginStatus: getLoginStatus(anonymity),
    userId: webUserId ? `ae:${webUserId}` : '',
    appSessionId: sessionId || '',
  };
}

export function trackCtaImpressionWithDelay(data: any): void {
  setTimeout(() => trackCtaImpression(data), 0);
}

export function trackCtaImpression(data: any): void {
  (window as any).pageDataTracker?.trackEvent('ctaImpression', {
    cta: {
      ids: [...data.ids],
    },
  });
}
